/** Service worker + update prompt (see updates.ts). Kept as the entry point main.tsx calls. */
import { startUpdateChecks } from "./updates.ts";

export function registerServiceWorker(): void {
  startUpdateChecks();
}
